import { SingleOption } from "components/selects/single-select/types";

export const getFilteredOptions = (options: SingleOption[], referenceValue: string | number) => {
  return options.filter(el => el.value !== referenceValue);
};
